import type { FaireProductEntity } from "../../entity_types/product";

export const p_vzv2may7uc: FaireProductEntity = {
  token: "p_vzv2may7uc",
  type: "product",
  name: "My Mom Is Magical! (A Hello!Lucky Book)",
  brandToken: "b_ap9qto2o",
  brandName: "Abrams",
  imageUrl:
    "https://cdn.faire.com/fastly/4f0c34504be126529b684c73158d42edefbe4e2d0c74f6bc227b42a8235f0d05.jpeg",
  galleryImageUrls: [],
  priceDollars: 6.27,
  description:
    "Filled with bright, adorable illustrations in Hello!Lucky’s inimitable style, young children will love the delightful ode to mothers in this sturdy board book. Featuring 11 things that make moms magical, this book also ends with a confidence boost to mom’s youngest fan—“kid, you’re magical too!” A must-have gift for new mothers, or for Mother’s Day, and sure to bring a smile to the whole family!",
  tags: [],
  msrpDollars: 12.31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:52.384Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
